import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowLeft({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowLeft</title>
      <path
        d="M20 12H4M4 12L10 6M4 12L10 18"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
